import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { DistrictService } from '@app/core';
import { District } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class DistrictResolverService {

    constructor(
        private districtService: DistrictService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<District> {
        const id = route.paramMap.get('id');

        if (id === null) {
            return of(new District());
        }

        return this.districtService.get(+id).pipe(
            map(district => {
                if (district) {
                    return district;
                }
                this.router.navigate(['/admin/district-list']);
                return null;
            })
        );
    }
}
